import request from '@/router/axios'
import env from '@/config/env'
/**
 * 获取当前登录用户所属供应商以及下属供应商
 * @param data
 *
 */
export const getCount = (data) => {
  return request({
    url: env.ferryUrl + '/sold-out/page',
    method: 'POST',
    data
  })
}

/**
 * 图片列表
 * @param data
 *
 */
export const getImgList = (id) => {
  return request({
    url: env.ferryUrl + `/sold-out/photo?id=${id}`,
    method: 'GET'
  })
}

/**
 * 提交异常
 * @param data
 *
 */
export const saveAbnormal = (data) => {
  return request({
    url: env.ferryUrl + `/sold-out/abnormal?id=${data.id}&abnormal=${data.abnormal}`,
    method: 'PUT'
  })
}

/**
 * 记录数据
 * @param data
 *
 */
export const getOperation = (data) => {
  return request({
    url: env.ferryUrl + '/sold-out/operation',
    method: 'POST',
    data
  })
}

/**
 * 数据统计
 * @param data
 *
 */
export const statistics = (data) => {
  return request({
    url: env.ferryUrl + '/sold-out/statistics',
    method: 'POST',
    data
  })
}

/**
 * 上座统计订单
 * @param data
 *
 */
export const soldOutOrder = (id) => {
  return request({
    url: env.ferryUrl + `/sold-out/order?id=${id}`,
    method: 'GET'
  })
}
